(function($) {
    $(function() {
        // Data Tables
        $('.dataTable').each(function(i){
            var searchLabel = $(this).attr('data-search-label');
            if (typeof searchLabel === typeof undefined || searchLabel === false) {
                searchLabel = 'Search:';
            }
            $(this).DataTable({
                dom: 'flrt<"dataTables_paging_footer"ip>',
                searchHighlight: true,
                "language": {
                    "search": searchLabel
                },
                initComplete: function () {
                    var table = this.api().table().node();
                    if ($(table).attr('data-column-filter')) {
                        var column = this.api().column($(table).data('column-filter'));
                        var div = $('<div class="dataTables_select"></div>')
                            .prependTo( $(this.api().table().container()));
                        var label = $('<label>Filter by:</label>')
                            .prependTo(div);
                        var select = $('<select><option value=""></option></select>')
                            .appendTo(label)
                            .on( 'change', function () {
                                var val = $.fn.dataTable.util.escapeRegex(
                                    $(this).val()
                                );
                                column
                                    .search(val)
                                    .draw();
                            } );
                        if ($(table).attr('data-column-filter-values')) {
                            var values = $(table).data('column-filter-values').split(',');
                            $.each(values, function(i, l) {
                                l = $.trim(l);
                                select.append( '<option value="'+l+'">'+l+'</option>' )
                            });
                        }
                        else {
                            column.data().unique().sort().each( function ( d, j ) {
                                select.append( '<option value="'+d+'">'+d+'</option>' );
                            } );
                        }
                        // Hide search filter
                        $(this.api().table().container()).find('.dataTables_filter').hide();
                    }
                }
            });
        });
    });
} )( jQuery );